import React from 'react';

/**
 * A page in the stack, consisting of a unique ID and a React node provider.
 */
export interface StackPage {
  id: string;
  nodeProvider: () => React.ReactNode;
}

export type StackApi = {
  push: (page: StackPage) => void;
  replace: (page: StackPage) => void;
  pop: () => void;
};

/**
 * Enumeration of possible visible stack item transitions.
 */
export enum StackPageDisplayState {
  VISIBLE,
  HIDDEN,
  ANIMATE_IN_FROM_RIGHT,
  ANIMATE_IN_FROM_LEFT,
  ANIMATE_OUT_TO_RIGHT,
  ANIMATE_OUT_TO_LEFT
}
